import { LabelHTMLAttributes } from "react";

export function Label(props: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      {...props}
      htmlFor={props.htmlFor}
      className="mx-4 block cursor-pointer"
    />
  );
}
